var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#003030"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2489_6003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3665 13.6673C15.8665 13.6673 16.3065 13.394 16.5332 12.9807L18.9198 8.65398C19.1665 8.21398 18.8465 7.66732 18.3398 7.66732H8.47317L7.8465 6.33398H5.6665V7.66732H6.99984L9.39984 12.7273L8.49984 14.354C8.01317 15.2473 8.65317 16.334 9.6665 16.334H17.6665V15.0007H9.6665L10.3998 13.6673H15.3665ZM9.1065 9.00065H17.2065L15.3665 12.334H10.6865L9.1065 9.00065ZM9.6665 17.0007C8.93317 17.0007 8.33984 17.6007 8.33984 18.334C8.33984 19.0673 8.93317 19.6673 9.6665 19.6673C10.3998 19.6673 10.9998 19.0673 10.9998 18.334C10.9998 17.6007 10.3998 17.0007 9.6665 17.0007ZM16.3332 17.0007C15.5998 17.0007 15.0065 17.6007 15.0065 18.334C15.0065 19.0673 15.5998 19.6673 16.3332 19.6673C17.0665 19.6673 17.6665 19.0673 17.6665 18.334C17.6665 17.6007 17.0665 17.0007 16.3332 17.0007Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2489_6003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.7c4a79ce6863b78cfb00c6316cca75f3.svg";
export { ForwardRef as ReactComponent };